<template>
  <section
    v-if="rows"
    class="dropdown">
    <button
      v-if="active.length !== rows.length"
      class="dropdown__btn dropdown__btn--show"
      @click="toggleAll()">
      Expand all ▼
    </button>
    <button
      v-else
      class="dropdown__btn dropdown__btn--hide"
      @click="toggleNone()">
      Hide all ▲
    </button>
    <ul class="dropdown__list">
      <li
        v-for="(row, key) in  rows"
        :key="`dropdown-row${key}`"
        class="row"
        :class="{
          'row--active': active.includes(key)
        }">
        <div
          class="row__header"
          @click.capture="toggleRow(key)">
          <h3 v-html="row.heading"></h3>
          <button>
            <span v-if="active.includes(key)">▲</span>
            <span v-else>▼</span>
          </button>
        </div>
        <div class="row__content">
          <div
            class="wysiwyg note"
            v-html="row.content"></div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    rows: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      active: []
    }
  },
  methods: {
    toggleRow(key) {
      if (this.active.includes(key)) {
        this.active.shift(key)
        return
      }

      this.active.push(key)
    },
    toggleAll() {
      this.active = this.rows.map((row, key) => {
        return key
      })
    },
    toggleNone() {
      this.active = []
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  width: 100%;

  &__list {
    .row {
      border-bottom: 3px solid;
      padding: 10px 0 7px 0;

      &--active {
        .row__header {
          button {
            // transform: rotate(-45deg);
          }
          h5 {
            color: $dk-grey;
          }
        }
        .row__content {
          display: block;
        }
      }
      &__header {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover {
          color: $dk-grey;
        }
        button {
          @include button_resets;
          padding: 6px;
          font-size: $heading;
        }
      }
      &__content {
        display: none;
        margin: $padding 0 #{$padding / 2} 0;
      }
    }
  }

  &__btn {
    @include button_resets;
    margin: $padding 0;
    font-size: $body;
    text-transform: uppercase;
    padding: 1px 0;

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: $mobile) {
    width: 100%;

    &__btn {
      font-size: $body--m;
    }

    &__list {
      .row {
        border-width: 2px;
        &__header {
          h3 {
            font-size: $body--m;
          }
          button {
            font-size: $heading--m;
            padding: 1px;
          }
        }
      }
    }
  }
}
</style>
